<template>
  <div>
    <!--面包屑导航区域-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>助教订单列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!--卡片视图区-->
    <el-card>
      <!--搜索与添加区域-->
      <el-row :gutter="20">
        <el-col :span="20">
          <el-input
              placeholder="请输入订单编号/用户手机号/教练手机号"
              clearable
              v-model="queryInfo.query"
              @clear="getOrderList()"
              style="width: 300px"
          >
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="getOrderList()"
            ></el-button>
          </el-input>
          <el-select
              v-model="queryInfo.store"
              placeholder="请选择门店"
              @change="getOrderList()"
              style="margin-left: 10px"
              clearable
              filterable
          >
            <el-option
                v-for="item in storelist"
                :key="item"
                :label="item"
                :value="item"
            ></el-option>
          </el-select>
          <el-select
              v-model="queryInfo.status"
              placeholder="请选择状态"
              @change="getOrderList()"
              style="margin-left: 10px"
              clearable
              filterable
          >
            <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
            ></el-option>
          </el-select>
          <el-select
              v-model="queryInfo.isTuikuan"
              placeholder="是否状态"
              @change="getOrderList()"
              style="margin-left: 10px"
              clearable
              filterable
          >
            <el-option
                v-for="item in refundStatus"
                :key="item.id"
                :label="item.label"
                :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
              v-model="customdate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="CustomeDate"
              style="margin: 0 10px"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="4" style="text-align: right">
          <el-button
              type="primary"
              icon="el-icon-upload"
              @click="exportOrders"
              v-permission="'btn:coachOrder:export'"
          >导出Excel</el-button>
        </el-col>
      </el-row>
      <br />
      <!--搜索与添加区域-->
      <!--用户列表区域-->
      <el-table
          :data="orderlist"
          style="width: 100%"
          ref="invoiceTable"
          stripe
          size="small"
          height="760"
          v-loading="isLoading"
      >
        <!-- <el-table-column label="ID" type="index"  width="50" fixed></el-table-column> -->
        <el-table-column label="序号" width="50" fixed>
          <template slot-scope="scope">
            {{
              (queryInfo.pagenum - 1) * queryInfo.pagesize + scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column
            label="订单编号"
            prop="orderno"
            min-width="110"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            label="用户名"
            prop="username"
            min-width="80"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            label="教练名称"
            prop="coachNickname"
            min-width="80"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            label="教练手机号"
            prop="coachTelephone"
            min-width="80"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            label="店铺名"
            prop="store"
            min-width="90"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
            label="金额"
            prop="total"
            min-width="60"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope" v-if="scope.row.total">
            <span style="color: #ff0000">￥{{ scope.row.total }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="退款金额"
            prop="refundTotal"
            min-width="70"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span style="color: #1989fa" v-if="scope.row.refundTotal"
            >￥{{ scope.row.refundTotal }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
            label="状态"
            prop="status"
            min-width="60"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag
                type="success"
                v-if="scope.row.status == '3'"
            >已完成</el-tag>
            <el-tag
                type="primary"
                v-if="scope.row.status == '1'"
            >已支付</el-tag>
            <el-tag
                type="primary"
                v-if="scope.row.status == '2'"
            >服务中</el-tag>
            <el-tag
                type="info"
                v-if="scope.row.status == '4'"
            >已退款</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="是否退款"
            min-width="60"
        >
          <template slot-scope="scope">
            <el-tag
                type="danger"
                v-if="scope.row.isTuikuan == '1'"
            >是</el-tag>
            <el-tag
                type="success"
                v-else
            >否</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="下单时间"
            min-width="110"
            prop="adddate"
        />
        <el-table-column
            label="预约时间"
            min-width="110"
        >
          <template slot-scope="scope">
            {{scope.row.reserverdate}} {{scope.row.reservertime}}
          </template>
        </el-table-column>
        <el-table-column
            label="退款日期"
            prop="refundTimeStr"
            min-width="110"
            :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="操作" min-width="160" >
          <template slot-scope="scope">
              <!-- 普通用户按原有逻辑显示 -->
              <el-button
                  type="warning"
                  icon="el-icon-delete"
                  size="mini"
                  v-if="!scope.row.refundTotal || scope.row.refundTotal < scope.row.total"
                  @click="DelCard(scope.row)"
                  v-permission="'btn:coachOrder:delete'"
              >退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--用户列表区域-->
      <!--分页区域-->
      <br />
      <div align="center">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pagenum"
            :page-sizes="[20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
            :page-size="queryInfo.pagesize"
            layout="total, sizes, prev, pager, next"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-card>

    <!--退款对话框-->
    <el-dialog
        title="退款"
        :visible.sync="refundDialogVisible"
        width="65%"
        @close="refundDialogClosed"
    >
      <el-form
          :model="refundForm"
          :rules="refundFormRules"
          ref="refundFormRef"
          label-width="100px"
      >
        <el-form-item label="订单金额" prop="amount">
          {{ refundForm.total }} 元
        </el-form-item>
        <el-form-item label="剩余可退金额" prop="syAmount">
          {{ refundForm.syAmount }} 元
        </el-form-item>
        <el-form-item label="退款金额" prop="refundTotal">
          <el-input
              v-model="refundForm.refundTotal"
              placeholder="请输入退款金额"
              style="width: 200px; margin-right: 10px"
              @input="validateRefundAmount"
              @keypress="checkNumberInput"
              @paste="handlePaste"
              @compositionend="handleCompositionEnd"
              type="text"
          ></el-input>
          元
        </el-form-item>
        <el-form-item label="退款说明" prop="refunddescribe">
          <el-input
              type="textarea"
              v-model="refundForm.refunddescribe"
              placeholder="请输入退款说明"
              :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRefund">确定退款</el-button>
      </span>
    </el-dialog>
    <!--退款对话框-->
  </div>
</template>

<script>
import { Loading } from "element-ui";
import axios from "axios";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      isLoading: false,
      refundDialogVisible: false,
      //获取订单列表的参数对象
      queryInfo: {
        query: "",
        store: "",
        status: "",
        startdate: "",
        enddate: "",
        isTuikuan: "",
        pagenum: 1,
        pagesize: 20,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      customdate: "",
      storelist: [],
      orderlist: [],
      statusList: [
        {
          id: '1',
          label: '已支付'
        },
        {
          id: '2',
          label: '服务中'
        },
        {
          id: '3',
          label: '已完成'
        },
        {
          id: '4',
          label: '已退款'
        }
      ],
      refundStatus: [
        {
          id: '1',
          label: '是'
        },
        {
          id: '0',
          label: '否'
        }
      ],
      total: 0,
      refundForm: {
        id: null,
        total: null, // 订单金额
        syAmount: null, //剩余可退金额
        refundTotal: "", // 退款金额，用户输入
        refunddescribe: "", // 退款说明，用户输入
        username: null // 用户手机号
      },
      // 退款表单验证规则
      refundFormRules: {
        refundTotal: [
          { required: true, message: "请输入退款金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入退款金额"));
              } else if (isNaN(value)) {
                callback(new Error("退款金额必须是数字"));
              } else if (parseFloat(value) <= 0) {
                callback(new Error("退款金额必须大于0"));
              } else if (
                  parseFloat(value) > parseFloat(this.refundForm.total)
              ) {
                callback(new Error("退款金额不能超过订单金额"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        refunddescribe: [
          { required: false, message: "请输入退款说明", trigger: "blur" },
        ],
      },
    }
  },
  created() {
    this.GetStore()
    this.getOrderList()
  },
  methods: {
    async GetStore() {
      const { data: res } = await this.$http.get("coachOrderStores/");
      this.storelist = res.data;
    },
    async getOrderList() {
      this.isLoading = true
      // 先清空列表，避免 Vue 虚拟 DOM 更新冲突
      this.orderlist = [];
      this.queryInfo.pagenum = 1
      try {
        const { data: res } = await this.$http.post("coachOrderList/", this.queryInfo);
        this.isLoading = false;
        // 检查响应状态和数据是否存在
        if (res.status == 1) {
          if (res.data.totalCount > 0) {
            this.total = res.data.totalCount;
          }

          // 处理订单列表数据
          if (res.data.list) {
            this.orderlist = res.data.list;
          } else {
            this.orderlist = [];
          }
        } else {
          // 请求失败或数据格式不正确
          this.total = 0;
          this.orderlist = [];
          if (res && res.message) {
            this.$message.error(res.message);
          }
        }
        console.log("订单列表数据:", this.orderlist);
      } catch (error) {
        this.isLoading = false;
        this.total = 0;
        this.orderlist = [];
        console.error("获取订单列表失败:", error);
        this.$message.error("获取订单列表失败");
      }
    },
    async getFyOrderList() {
      this.isLoading = true
      const { data: res } = await this.$http.post("coachOrderList/", this.queryInfo);
      this.isLoading = false
      if (res.status == 1) {
        if (res.data.totalCount > 0) {
          this.total = res.data.totalCount;
        }

        // 处理订单列表数据
        this.orderlist = res.data.list
      }
      console.log("订单列表数据:", this.orderlist);
    },
    CustomeDate() {
      if (this.customdate == null) {
        this.queryInfo.startdate = "";
        this.queryInfo.enddate = "";
      } else {
        this.queryInfo.startdate = this.customdate[0];
        this.queryInfo.enddate = this.customdate[1];
      }
      this.getOrderList();
    },
    // 导出订单数据
    exportOrders() {
      let downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios
          .get("/coachOrderAllList/export", {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            responseType: "blob",
            params: this.queryInfo,
          })
          .then(async (data) => {
            const isBlob = data.data.type !== "application/json";
            if (isBlob) {
              const blob = new Blob([data.data]);
              saveAs(blob, `助教订单_${new Date().getTime()}.xlsx`);
            } else {
              this.$message.error("导出订单数据失败");
            }
            downloadLoadingInstance.close();
          })
          .catch((r) => {
            console.error(r);
            this.$message.error("下载文件出现错误，请联系管理员！");
            downloadLoadingInstance.close();
          });
    },
    handleSizeChange(newSize) {
      this.isLoading = true;
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getFyOrderList();
    },
    handleCurrentChange(newPage) {
      this.isLoading = true;
      // console.log(newPage)
      this.queryInfo.pagenum = newPage;
      this.getFyOrderList();
    },
    // 打开退款对话框
    async DelCard(row) {
      // 设置退款对话框数据
      this.refundForm = {
        id: row.id,
        total: row.total || 0, // 订单金额
        syAmount: ((row.total || 0) - (row.refundTotal || 0)), //剩余可退金额
        refundTotal: "", // 退款金额，用户输入
        refunddescribe: "", // 退款说明，用户输入
        username: row.username || "", // 用户手机号
      };

      // 显示退款对话框
      this.refundDialogVisible = true;
    },

    refundDialogClosed() {
      this.$refs.refundFormRef.resetFields();
      // 重置退款表单
      this.refundForm = {
        id: "",
        total: 0,
        syAmount: 0,
        refundTotal: "",
        refunddescribe: "",
        username: "",
      };
    },

    // 验证退款金额，确保只能输入数字且不超过订单金额
    validateRefundAmount() {
      // 去除非数字字符
      this.refundForm.refundTotal = this.refundForm.refundTotal.replace(
          /[^\d.]/g,
          ""
      );

      // 确保只有一个小数点
      const parts = this.refundForm.refundTotal.split(".");
      if (parts.length > 2) {
        this.refundForm.refundTotal = parts[0] + "." + parts.slice(1).join("");
      }

      // 确保小数点后最多两位
      if (parts.length === 2 && parts[1].length > 2) {
        this.refundForm.refundTotal =
            parts[0] + "." + parts[1].substring(0, 2);
      }

      // 如果输入的金额大于订单金额，自动设置为订单金额
      if (
          this.refundForm.refundTotal &&
          Number(this.refundForm.refundTotal) > Number(this.refundForm.syAmount)
      ) {
        this.refundForm.refundTotal = this.refundForm.syAmount;
        this.$message.info("退款金额不能超过订单金额，已自动调整为订单可退金额");
      }
    },
    // 检查键盘输入，只允许输入数字和小数点
    checkNumberInput(e) {
      // 只允许数字和小数点
      const charCode = e.which ? e.which : e.keyCode;

      // 如果输入的不是数字且不是小数点，阻止输入
      if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
      ) {
        e.preventDefault();
        return false;
      }

      // 如果已经有小数点了，不允许再输入小数点
      if (charCode === 46 && this.refundForm.refundTotal.includes(".")) {
        e.preventDefault();
        return false;
      }

      return true;
    },
    // 处理粘贴事件
    handlePaste(e) {
      // 阻止默认粘贴行为
      e.preventDefault();

      // 获取粘贴的文本
      const pastedText = (e.clipboardData || window.clipboardData).getData(
          "text"
      );

      // 只允许粘贴数字和小数点
      const validText = pastedText.replace(/[^\d.]/g, "");

      // 处理小数点
      let parts = validText.split(".");
      let result = parts[0];
      if (parts.length > 1) {
        result += "." + parts[1].substring(0, 2); // 只保留小数点后两位
      }

      // 将处理后的文本插入到当前值中
      const currentValue = this.refundForm.refundTotal || "";
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;

      this.refundForm.refundTotal =
          currentValue.substring(0, selectionStart) +
          result +
          currentValue.substring(selectionEnd);

      // 立即验证
      this.validateRefundAmount();
    },
    // 处理中文输入法结束事件
    handleCompositionEnd(e) {
      // 中文输入法完成后立即验证
      this.validateRefundAmount();
    },
    // 提交退款
    async submitRefund() {
      // 验证表单
      this.$refs.refundFormRef.validate(async (valid) => {
        if (!valid) return;

        // 再次确认
        const confirmResult = await this.$confirm(
            "确定要对此订单进行退款吗？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
        ).catch((err) => err);

        if (confirmResult !== "confirm") {
          return this.$message.info("已取消退款！");
        }

        // 检查是否填写了退款说明
        if (
            !this.refundForm.refunddescribe ||
            this.refundForm.refunddescribe.trim() === ""
        ) {
          return this.$message.error("请填写退款说明");
        }

        if (this.refundForm.refundTotal <= 0) {
          return this.$message.error("退款金额必须大于0");
        }

        // 使用用户输入的退款说明
        let refundDesc = this.refundForm.refunddescribe;

        // 发送退款请求
        const admin_token = window.sessionStorage.getItem("admin_token");
        const { data: res } = await this.$http.post("coachOrderdel/", {
          admin_token: admin_token,
          id: this.refundForm.id,
          refundTotal: this.refundForm.refundTotal,
          refunddescribe: refundDesc,
          audit_status: true, // 同意退款
        });

        if (res.code === 200) {
          this.$message({ message: res.msg, type: "success" });
          // 关闭对话框
          this.refundDialogVisible = false;
          // 刷新列表
          this.getOrderList();
        } else {
          this.$message({ message: res.msg || "退款失败！", type: "error" });
        }
      });
    },
  }
}

</script>

<style scoped>

</style>
